import { createSeedData } from "./seed";

const STORAGE_KEY = "dobry-ai-crm-v1";
const PERSONA_KEY = "dobry-ai-crm-persona";

const clone = (value) => JSON.parse(JSON.stringify(value));
const uid = (prefix) => `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`;

export const crmRepository = {
  load() {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (!stored) {
        const seed = createSeedData();
        localStorage.setItem(STORAGE_KEY, JSON.stringify(seed));
        return seed;
      }
      return JSON.parse(stored);
    } catch {
      return createSeedData();
    }
  },
  save(data) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    return clone(data);
  },
  reset() {
    const seed = createSeedData();
    this.save(seed);
    return seed;
  },
  getPersona() {
    return localStorage.getItem(PERSONA_KEY) || "sprzedaz";
  },
  setPersona(persona) {
    localStorage.setItem(PERSONA_KEY, persona);
  },
  uid,
};
